'use strict';

var _extends = require('../../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var classNames = require('classnames');
require('prop-types');
var TextFormat = require('../../../../utils/TextFormat.js');
var Typography = require('../../Typography/Typography.js');
var makeStyles = require('../../../Styles/makeStyles.js');
var ExpandableTableCell = require('../ExpandableTableCell.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var useStyles = makeStyles["default"]({
  wrapper: {
    minHeight: ExpandableTableCell.TWO_ROW_HEIGHT
  }
});

var DateTimeTableCellContent = function DateTimeTableCellContent(_ref) {
  var _ref$wrapperComponent = _ref.wrapperComponent,
      Wrapper = _ref$wrapperComponent === void 0 ? 'div' : _ref$wrapperComponent,
      _ref$wrapperProps = _ref.wrapperProps,
      wrapperProps = _ref$wrapperProps === void 0 ? {} : _ref$wrapperProps,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ["wrapperComponent", "wrapperProps", "children"]);

  var _useStyles = useStyles(),
      wrapper = _useStyles.wrapper;

  var dayAndTime = TextFormat.formatDayAndTime(children);

  var className = wrapperProps.className,
      otherWrapperProps = objectWithoutProperties(wrapperProps, ["className"]);

  return React__default["default"].createElement(Wrapper, _extends["default"]({
    className: classNames__default["default"](wrapper, className)
  }, otherWrapperProps), React__default["default"].createElement(Typography, _extends["default"]({
    variant: "body1"
  }, props), TextFormat.formatDate(children)), dayAndTime && React__default["default"].createElement(Typography, _extends["default"]({
    variant: "body1"
  }, props), dayAndTime));
};

module.exports = DateTimeTableCellContent;
